import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=1ebde5ea&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"
import style0 from "./Discount.vue?vue&type=style&index=0&id=1ebde5ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebde5ea",
  null
  
)

export default component.exports